(() => {
  const desktopQuery = window.matchMedia('(min-width: 990px)');

  const getItems = (gallery) => Array.from(gallery.querySelectorAll('[id^="GalleryThumbnails"] [data-target]'));

  const syncControls = (gallery) => {
    const viewer = gallery.querySelector('[id^="GalleryViewer"]');
    const activeMediaId = viewer?.querySelector('[data-media-id].is-active')?.dataset.mediaId;
    const items = getItems(gallery);
    const activeIndex = items.findIndex((item) => item.dataset.target === activeMediaId);
    const previous = viewer?.querySelector('.slider-button--prev');
    const next = viewer?.querySelector('.slider-button--next');

    if (!previous || !next || activeIndex < 0) return;
    previous.toggleAttribute('disabled', activeIndex === 0);
    next.toggleAttribute('disabled', activeIndex === items.length - 1);
  };

  const changeMedia = (gallery, direction) => {
    const viewer = gallery.querySelector('[id^="GalleryViewer"]');
    const activeMediaId = viewer?.querySelector('[data-media-id].is-active')?.dataset.mediaId;
    const items = getItems(gallery);
    const activeIndex = items.findIndex((item) => item.dataset.target === activeMediaId);
    const nextItem = items[activeIndex + direction];

    if (!nextItem) return;
    nextItem.querySelector('button')?.click();
    window.requestAnimationFrame(() => syncControls(gallery));
  };

  const setupGallery = (gallery) => {
    if (gallery.dataset.leSevenDesktopArrowsReady === 'true') return;

    const viewer = gallery.querySelector('[id^="GalleryViewer"]');
    const previous = viewer?.querySelector('.slider-button--prev');
    const next = viewer?.querySelector('.slider-button--next');
    if (!viewer || !previous || !next) return;

    gallery.dataset.leSevenDesktopArrowsReady = 'true';
    [[previous, -1], [next, 1]].forEach(([button, direction]) => {
      button.addEventListener('click', (event) => {
        if (!desktopQuery.matches) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        changeMedia(gallery, direction);
      }, true);
    });

    gallery.querySelector('[id^="GalleryThumbnails"]')?.addEventListener('click', () => {
      window.requestAnimationFrame(() => syncControls(gallery));
    });

    desktopQuery.addEventListener('change', () => syncControls(gallery));
    syncControls(gallery);
  };

  const init = () => document.querySelectorAll('.le-seven-pdp media-gallery').forEach(setupGallery);
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
})();
